<div *ngIf="rseGroup">
    <div class="card my-2 mr-2 full-width rseGroupWrapper">
        <span *ngIf="sharedDatasSvc.debug">dependencyOffsetLevel = {{supplierAnswsers.dependencyOffsetLevel(rseGroup)}}</span>
        <div class="card-header rsqGroupHeader" *ngIf="!!rseGroup.LblCod">
            <label class="control-label" [paflabel]="rseGroup.LblCod"></label>
        </div>
        <div class="card-body d-flex flex-column align-items-stretch justify-content-start pl-1 pr-1">
            <div *ngFor="let q of visibleGrpQuestions" [ngStyle]="supplierAnswsers.ngStyle(q)">
                <app-supplier-rse-answer [rseQuestion]="q" [supplierAnswsers]="supplierAnswsers"  class="full-width" [readonly]="readonly" [frmRse]="frmRse" ></app-supplier-rse-answer>
            </div>
            <div *ngFor="let g of visibleSubGroups" [ngStyle]="supplierAnswsers.ngStyle(g)">
                <app-supplier-rse-qst-group [rseGroup]="g"[supplierAnswsers]="supplierAnswsers" class="full-width" [readonly]="readonly" [frmRse]="frmRse" ></app-supplier-rse-qst-group>
            </div>
        </div>
    </div>
</div>